import { Form, Select } from 'antd'
import styled from 'styled-components'

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    width: ${props => props.width || '132px'};
    height: ${props => props.height || '42px'} !important;
    background: #fafafb !important;
    border: ${props =>
      props.disabled ? '1px solid #E6E7EA' : '1px solid #D6DBF7'};
    box-shadow: ${props =>
      props.disabled ? 'unset' : '0px 2px 6px 0px #7b61ff26'};
    display: flex;
    align-items: center;
    color: #7d7d7d !important;
    font: Plus Jakarta Sans !important;
    font-weight: 500 !important;
    cursor: pointer !important; // Ensure pointer cursor

    input {
      cursor: pointer !important; // Ensure input cursor stays pointer
    }
  }

  .ant-select-selection-placeholder {
    color: #bfbfbf;
    font-size: 12px;
    cursor: pointer !important;
    font-weight: 500 !important;
  }

  .ant-select-selection-item {
    font-size: 12px;
    cursor: pointer !important;
    font-weight: 500 !important;
  }

  // Override Ant Design's disabled behavior
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    cursor: pointer !important; // Force pointer cursor
    opacity: 1 !important;
    pointer-events: auto !important; // Ensure events are allowed
    font-weight: 500 !important;
  }

  .ant-select-disabled.ant-select-selector input {
    cursor: pointer !important; // Override not-allowed cursor on input
    font-weight: 500 !important;
  }
`

export default StyledSelect

export const StyledFormItem = styled(Form.Item)`
  .ant-select {
    width: ${({ inputWidth }) => inputWidth || 'auto'};
  }
`
